import Vue from 'vue';
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    token:'',
    user:{},
    searchWord:'',
    showTip:false
}

const mutations = {
    getToken(state,token) {
        state.token = token
        sessionStorage.setItem("token",token)
    },
    changeShoptip(state) {
        state.showTip = true
    },
    changeHidetip(state) {
        state.showTip = false
    },
    changesearchVal(state,val) {
        state.searchWord = val
    }
}

const getters = {
   
}

const actions = {
}

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})


// WEBPACK FOOTER //
// ./src/store/index.js